// ----------------------------------------------------------------------

export default function Button({ theme }) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          // Remove any default hover styles that affect background color
          '&:hover': {
            boxShadow: '0px 2px 4px 0px rgba(145, 158, 171, 0.32)',
          },
        },
        sizeSmall: {
          height: 32,
        },
        sizeMedium: {
          height: 36,
        },
        sizeLarge: {
          height: 40,
        },

        containedInherit: {
          '&:hover': {
            boxShadow: '0px 2px 4px 0px rgba(145, 158, 171, 0.32)',
            backgroundColor: 'transparent', // Ensure background color doesn't change on hover
          },
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            boxShadow: '0px 2px 4px 0px rgba(145, 158, 171, 0.32)',
            backgroundColor: 'transparent', // Ensure background color doesn't change on hover
          },
        },
        textInherit: {
          '&:hover': {
            boxShadow: '0px 2px 4px 0px rgba(145, 158, 171, 0.32)',
            backgroundColor: 'transparent', // Ensure background color doesn't change on hover
          },
        },
      },
    },
  }
}
